(function () {
  'use strict';

  var layoutFrame = null;
  var canvasRetryTimer = null;

  function getProductScope() {
    return document.querySelector('.sf-prod__info') || document;
  }

  function getProductActions(scope) {
    var actions = scope.querySelectorAll('.product-form__actions');
    var index;

    for (index = 0; index < actions.length; index += 1) {
      if (actions[index].querySelector('.add-to-cart, [name="add"]')) {
        return actions[index];
      }
    }

    return actions[0] || null;
  }

  function applyCustomilyLayout() {
    var scope = getProductScope();
    var options = document.getElementById('customily-options');
    var actions = getProductActions(scope);
    var buttonsTarget = scope.querySelector('.product-form__buttons') || actions;
    var previewButton =
      document.getElementById('customily-preview-button') ||
      document.querySelector('.customily-preview-button');
    var quantityLabels = scope.querySelectorAll('.prod__option-label.prod__option-label__quantity');

    if (
      options &&
      buttonsTarget &&
      buttonsTarget.parentNode &&
      options.nextElementSibling !== buttonsTarget
    ) {
      buttonsTarget.parentNode.insertBefore(options, buttonsTarget);
    }

    if (previewButton && actions && previewButton.parentNode !== actions) {
      actions.insertBefore(previewButton, actions.firstChild);
    }

    Array.prototype.forEach.call(quantityLabels, function (label) {
      label.classList.remove('md:block');
    });
  }

  function scheduleCustomilyLayout() {
    if (layoutFrame) return;

    layoutFrame = window.requestAnimationFrame(function () {
      layoutFrame = null;
      applyCustomilyLayout();
    });
  }

  function syncLivePreviewCanvas(attempt) {
    window.requestAnimationFrame(function () {
      var customilyCanvas = document.querySelector('.cl-canvas-container');
      var sourceCanvas = document.querySelector('.canvas-container');
      var stickyMobile = document.querySelector('.csh-sticky-mobile-container');
      var height;
      var heightValue;

      if (stickyMobile && stickyMobile.parentElement) {
        stickyMobile.parentElement.style.zIndex = '3';
      }

      if (!customilyCanvas || !sourceCanvas) return;

      height = sourceCanvas.getBoundingClientRect().height;

      if (height > 1 && Number.isFinite(height)) {
        heightValue = Math.round(height * 100) / 100 + 'px';
        customilyCanvas.style.height = heightValue;

        if (customilyCanvas.parentElement) {
          customilyCanvas.parentElement.style.height = heightValue;
        }

        return;
      }

      if (attempt < 4) {
        window.clearTimeout(canvasRetryTimer);
        canvasRetryTimer = window.setTimeout(function () {
          syncLivePreviewCanvas(attempt + 1);
        }, 80);
      }
    });
  }

  var legacyOnAppLoadedHooks = [];
  var nativeReplayGuardGeneration = 0;
  var activeNativeReplayGuard = 0;

  function isObject(value) {
    return value !== null && (typeof value === 'object' || typeof value === 'function');
  }

  function rememberLegacyOnAppLoaded(hook) {
    if (
      typeof hook === 'function' &&
      hook !== customilyOnAppLoadedDispatcher &&
      legacyOnAppLoadedHooks.indexOf(hook) === -1
    ) {
      legacyOnAppLoadedHooks.push(hook);
    }
  }

  function customilyOnAppLoadedDispatcher() {
    var context = this;
    var args = arguments;
    var returnValue;

    legacyOnAppLoadedHooks.slice().forEach(function (hook) {
      try {
        returnValue = hook.apply(context, args);
      } catch (error) {
        // A legacy Customily hook must not stop the safe theme integration.
      }
    });

    scheduleCustomilyLayout();
    return returnValue;
  }

  function defineStableObjectProperty(parent, key, store, merge) {
    var descriptor;

    try {
      descriptor = Object.getOwnPropertyDescriptor(parent, key);
      if (descriptor && descriptor.configurable === false) {
        return parent[key] === store;
      }

      Object.defineProperty(parent, key, {
        configurable: false,
        enumerable: true,
        get: function () {
          return store;
        },
        set: function (value) {
          if (value !== store) merge(value);
        }
      });
      return true;
    } catch (error) {
      try {
        parent[key] = store;
      } catch (assignmentError) {
        // The click-time enforcement below remains as a safe fallback.
      }
      return parent[key] === store;
    }
  }

  function defineLockedConfigValue(target, key, value) {
    var descriptor;

    try {
      descriptor = Object.getOwnPropertyDescriptor(target, key);
      if (descriptor && descriptor.configurable === false) {
        try {
          target[key] = value;
        } catch (assignmentError) {
          // Keep the existing non-configurable value.
        }
        return target[key] === value;
      }

      Object.defineProperty(target, key, {
        configurable: false,
        enumerable: true,
        get: function () {
          return value;
        },
        set: function () {
          // Customily product settings must not restore the second ATC path.
        }
      });
      return true;
    } catch (error) {
      try {
        target[key] = value;
      } catch (assignmentError) {
        // The click-time enforcement below remains as a safe fallback.
      }
      return target[key] === value;
    }
  }

  function createCustomilyConfigController() {
    var existingConfig = isObject(window.customilyShopify) ? window.customilyShopify : {};
    var addToCartStore = isObject(existingConfig.addToCart) ? existingConfig.addToCart : {};
    var hooksStore = isObject(existingConfig.hooks) ? existingConfig.hooks : {};
    var lockedAddToCartKeys = {
      useAjax: true,
      triggerStoreButtonClick: false,
      openCartDrawerAfterAtc: false
    };
    var controller;

    rememberLegacyOnAppLoaded(hooksStore.onAppLoaded);

    function mergeAddToCart(value) {
      if (!isObject(value) || value === addToCartStore) return;

      Object.keys(value).forEach(function (key) {
        if (!Object.prototype.hasOwnProperty.call(lockedAddToCartKeys, key)) {
          addToCartStore[key] = value[key];
        }
      });
    }

    function mergeHooks(value) {
      if (!isObject(value) || value === hooksStore) return;

      Object.keys(value).forEach(function (key) {
        if (key === 'onAppLoaded') {
          rememberLegacyOnAppLoaded(value[key]);
        } else {
          hooksStore[key] = value[key];
        }
      });
    }

    function mergeRoot(value) {
      if (!isObject(value) || value === existingConfig) return;

      Object.keys(value).forEach(function (key) {
        if (key === 'addToCart') {
          mergeAddToCart(value[key]);
        } else if (key === 'hooks') {
          mergeHooks(value[key]);
        } else {
          existingConfig[key] = value[key];
        }
      });
    }

    defineLockedConfigValue(addToCartStore, 'useAjax', true);
    defineLockedConfigValue(addToCartStore, 'triggerStoreButtonClick', false);
    defineLockedConfigValue(addToCartStore, 'openCartDrawerAfterAtc', false);

    try {
      Object.defineProperty(hooksStore, 'onAppLoaded', {
        configurable: false,
        enumerable: true,
        get: function () {
          return customilyOnAppLoadedDispatcher;
        },
        set: function (hook) {
          rememberLegacyOnAppLoaded(hook);
        }
      });
    } catch (error) {
      rememberLegacyOnAppLoaded(hooksStore.onAppLoaded);
      hooksStore.onAppLoaded = customilyOnAppLoadedDispatcher;
    }

    defineStableObjectProperty(existingConfig, 'addToCart', addToCartStore, mergeAddToCart);
    defineStableObjectProperty(existingConfig, 'hooks', hooksStore, mergeHooks);
    defineStableObjectProperty(window, 'customilyShopify', existingConfig, mergeRoot);

    controller = {
      enforce: function () {
        defineLockedConfigValue(addToCartStore, 'useAjax', true);
        defineLockedConfigValue(addToCartStore, 'triggerStoreButtonClick', false);
        defineLockedConfigValue(addToCartStore, 'openCartDrawerAfterAtc', false);
        return existingConfig;
      }
    };

    return controller;
  }

  function enforceCustomilyAddToCartConfig() {
    var controller = window.CustomilyThemeConfigController;

    if (!controller || typeof controller.enforce !== 'function') {
      controller = createCustomilyConfigController();
      window.CustomilyThemeConfigController = controller;
    }

    return controller.enforce();
  }

  function installCustomilyConfig() {
    var config = enforceCustomilyAddToCartConfig();

    config.livePreviewBeforeGallery = true;
    window.CustomilyThemeAppLoadedHookInstalled = true;
  }

  function armNativeStoreButtonReplayGuard() {
    var generation;

    enforceCustomilyAddToCartConfig();
    generation = ++nativeReplayGuardGeneration;
    activeNativeReplayGuard = generation;

    window.setTimeout(function () {
      if (activeNativeReplayGuard === generation) {
        activeNativeReplayGuard = 0;
      }
    }, 0);
  }

  function getEventMatch(event, selector) {
    var path;
    var index;
    var node;

    if (event && typeof event.composedPath === 'function') {
      path = event.composedPath();
      for (index = 0; index < path.length; index += 1) {
        node = path[index];
        if (node && typeof node.matches === 'function' && node.matches(selector)) {
          return node;
        }
      }
    }

    node = event && event.target;
    return node && typeof node.closest === 'function' ? node.closest(selector) : null;
  }

  function stopSyntheticNativeCartEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }

  installCustomilyConfig();
  window.CustomilyThemeEnforceAddToCartConfig = enforceCustomilyAddToCartConfig;
  window.addEventListener('DOMContentLoaded', enforceCustomilyAddToCartConfig, { once: true });
  window.addEventListener('customily-options-loaded', enforceCustomilyAddToCartConfig);

  if (!window.CustomilyThemeNativeReplayGuardInstalled) {
    window.addEventListener(
      'customily-add-to-cart-completed',
      armNativeStoreButtonReplayGuard,
      true
    );

    document.addEventListener('click', function (event) {
      var customilyCartButton = getEventMatch(event, '#customily-cart-btn');
      var nativeStoreButton;

      if (customilyCartButton) {
        enforceCustomilyAddToCartConfig();
        return;
      }

      nativeStoreButton = getEventMatch(
        event,
        '.product-form__actions button[name="add"], ' +
        '.product-form__actions .add-to-cart, ' +
        'form[data-type="add-to-cart-form"] button[name="add"]'
      );

      if (
        nativeStoreButton &&
        activeNativeReplayGuard !== 0 &&
        event.isTrusted === false
      ) {
        stopSyntheticNativeCartEvent(event);
      }
    }, true);

    document.addEventListener('submit', function (event) {
      var productForm = getEventMatch(
        event,
        'product-form, .main-product-form, form[action*="/cart/add"]'
      );

      if (
        productForm &&
        activeNativeReplayGuard !== 0 &&
        event.isTrusted === false
      ) {
        stopSyntheticNativeCartEvent(event);
      }
    }, true);

    window.CustomilyThemeNativeReplayGuardInstalled = true;
  }

  if (window.CustomilyPreviewModalEnhancer && typeof window.CustomilyPreviewModalEnhancer.refresh === 'function') {
    scheduleCustomilyLayout();
    window.CustomilyPreviewModalEnhancer.refresh();
    return;
  }

  var MODAL_SELECTOR = '.customily-modal-preview-only';
  var PROXY_SELECTOR = '[data-customily-preview-atc-proxy]';
  var observer = null;
  var resetTimer = null;
  var modalCloseTimer = null;
  var cartConfirmed = false;

  var translations = {
    en: {
      addToCart: 'ADD TO CART',
      adding: 'ADDING…',
      added: 'ADDED TO CART ✓',
      retry: 'PLEASE TRY AGAIN'
    },
    de: {
      addToCart: 'IN DEN WARENKORB',
      adding: 'WIRD HINZUGEFÜGT…',
      added: 'ZUM WARENKORB HINZUGEFÜGT ✓',
      retry: 'BITTE ERNEUT VERSUCHEN'
    },
    es: {
      addToCart: 'AÑADIR AL CARRITO',
      adding: 'AÑADIENDO…',
      added: 'AÑADIDO AL CARRITO ✓',
      retry: 'INTÉNTALO DE NUEVO'
    },
    fr: {
      addToCart: 'AJOUTER AU PANIER',
      adding: 'AJOUT EN COURS…',
      added: 'AJOUTÉ AU PANIER ✓',
      retry: 'VEUILLEZ RÉESSAYER'
    },
    it: {
      addToCart: 'AGGIUNGI AL CARRELLO',
      adding: 'AGGIUNTA…',
      added: 'AGGIUNTO AL CARRELLO ✓',
      retry: 'RIPROVA'
    }
  };

  function getLocale() {
    var locale =
      (typeof window.shopLocale === 'string' && window.shopLocale) ||
      document.documentElement.lang ||
      'en';

    locale = locale.toLowerCase().split('-')[0];
    return translations[locale] ? locale : 'en';
  }

  function text(key) {
    return translations[getLocale()][key] || translations.en[key] || key;
  }

  function getProxyButtons() {
    return document.querySelectorAll(PROXY_SELECTOR);
  }

  function setProxyState(label, disabled) {
    Array.prototype.forEach.call(getProxyButtons(), function (button) {
      button.textContent = label;
      button.disabled = !!disabled;
      button.setAttribute('aria-busy', disabled ? 'true' : 'false');
    });
  }

  function dispatchThemeCartRequested() {
    var event;

    if (typeof window.CustomEvent === 'function') {
      event = new window.CustomEvent('customily-theme-cart-requested');
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent('customily-theme-cart-requested', false, false, null);
    }

    window.dispatchEvent(event);
  }

  function closePreviewModal(modal) {
    var nativeClose;

    if (!modal) return;

    nativeClose = modal.querySelector('.customily-close-button');
    if (nativeClose && typeof nativeClose.click === 'function') {
      nativeClose.click();
    }

    window.setTimeout(function () {
      var style;

      if (!modal || !document.documentElement.contains(modal)) return;

      style = window.getComputedStyle(modal);
      if (style.display === 'none' || style.visibility === 'hidden') return;

      modal.style.display = 'none';
      modal.setAttribute('aria-hidden', 'true');

      if (typeof window.CustomEvent === 'function') {
        window.dispatchEvent(new window.CustomEvent('customily-preview-modal-hide'));
      }
    }, 120);
  }

  function closeVisiblePreviewModals() {
    Array.prototype.forEach.call(document.querySelectorAll(MODAL_SELECTOR), function (modal) {
      var style = window.getComputedStyle(modal);

      if (style.display !== 'none' && style.visibility !== 'hidden') {
        closePreviewModal(modal);
      }
    });
  }

  function handleProxyClick(event) {
    var modal = event.currentTarget.closest(MODAL_SELECTOR);
    var nativeClose = modal && modal.querySelector('.customily-close-button');
    var cartButton = document.getElementById('customily-cart-btn');

    if (!cartButton || cartButton.disabled) {
      setProxyState(text('retry'), false);
      return;
    }

    enforceCustomilyAddToCartConfig();
    handleAdding();
    dispatchThemeCartRequested();

    if (nativeClose && typeof nativeClose.click === 'function') {
      nativeClose.click();
    }

    window.requestAnimationFrame(function () {
      cartButton.click();
    });
  }

  function enhanceModal(modal) {
    var main;
    var button;

    if (!modal) return;

    main = modal.querySelector('.main');
    if (!main || main.querySelector(PROXY_SELECTOR)) return;

    button = document.createElement('button');
    button.type = 'button';
    button.className =
      'customily-theme-preview-atc button button--primary button--filled button--primary__filled ld-over-inverse';
    button.setAttribute('data-customily-preview-atc-proxy', '');
    button.textContent = text('addToCart');
    button.addEventListener('click', handleProxyClick);

    main.appendChild(button);
    modal.classList.add('customily-theme-preview-enhanced');
  }

  function inspectNode(node) {
    var modal;
    var nestedModals;

    if (!node || node.nodeType !== 1) return;

    if (node.matches && node.matches(MODAL_SELECTOR)) {
      enhanceModal(node);
      return;
    }

    modal = node.closest && node.closest(MODAL_SELECTOR);
    if (modal) enhanceModal(modal);

    nestedModals = node.querySelectorAll && node.querySelectorAll(MODAL_SELECTOR);
    if (nestedModals) {
      Array.prototype.forEach.call(nestedModals, enhanceModal);
    }
  }

  function refresh() {
    Array.prototype.forEach.call(document.querySelectorAll(MODAL_SELECTOR), enhanceModal);
  }

  function startObserver() {
    if (observer || !document.body) return;

    observer = new MutationObserver(function (records) {
      scheduleCustomilyLayout();

      records.forEach(function (record) {
        Array.prototype.forEach.call(record.addedNodes, inspectNode);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  function handleAdding() {
    window.clearTimeout(resetTimer);
    window.clearTimeout(modalCloseTimer);
    cartConfirmed = false;
    setProxyState(text('adding'), true);
  }

  function handleAdded() {
    window.clearTimeout(resetTimer);
    window.clearTimeout(modalCloseTimer);
    cartConfirmed = true;
    setProxyState(text('added'), true);

    modalCloseTimer = window.setTimeout(function () {
      closeVisiblePreviewModals();
    }, 650);

    resetTimer = window.setTimeout(function () {
      setProxyState(text('addToCart'), false);
    }, 2200);
  }

  function handleError() {
    window.clearTimeout(resetTimer);
    setProxyState(text('retry'), false);
  }

  function handleCartError() {
    if (cartConfirmed) return;
    handleError();
  }

  function handleRequiredError() {
    cartConfirmed = false;
    handleError();
  }

  window.addEventListener('customily-preview-modal-show', refresh);
  window.addEventListener('customily-after-modal-show', refresh);
  window.addEventListener('customily-options-loaded', scheduleCustomilyLayout);
  window.addEventListener('customily-live-preview-shown', function () {
    syncLivePreviewCanvas(0);
  });
  window.addEventListener('customily-starts-adding-to-cart', handleAdding);
  window.addEventListener('customily-add-to-cart-completed', handleAdded);
  window.addEventListener('customily-theme-cart-confirmed', handleAdded);
  window.addEventListener('customily-theme-cart-failed', handleCartError);
  window.addEventListener('customily-required-error', handleRequiredError);
  window.addEventListener('customily-add-addons-error', handleCartError);
  window.addEventListener('customily-add-addond-error', handleCartError);
  window.addEventListener('resize', function () {
    if (document.querySelector('.cl-canvas-container')) {
      syncLivePreviewCanvas(0);
    }
  });

  window.CustomilyPreviewModalEnhancer = {
    refresh: refresh,
    refreshLayout: scheduleCustomilyLayout
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleCustomilyLayout();
      refresh();
      startObserver();
    }, { once: true });
  } else {
    scheduleCustomilyLayout();
    refresh();
    startObserver();
  }
})();
